// NOTE: Wraps useOrganizationStats (which uses GET_DASHBOARD_STATS).
// Org-level stats are date-range filtered when dateRange is provided.

import { useOrganizationStats } from '../organizations/useOrganizationStats';

interface DateRange {
  from: Date | null;
  to: Date | null;
}

export const useStats = (dateRange: DateRange) => {
  const { stats, isLoading, error } = useOrganizationStats(dateRange);

  return {
    callsMade: stats?.totalCalls ?? 0,
    contactsCalled: stats?.uniqueContactsCallsAnswered ?? 0,
    conversations: stats?.uniqueContactsCallsAnswered ?? 0,
    totalCallDuration: '0 h(rs) and 0 min(s)',
    opportunities: 0,
    isLoading,
    error,
    getFilteredCalls: async (_type: string) => [] as unknown[],
    refetch: async () => {},
  };
};

export default useStats;
